const enablePossessionStorage = () => {
  console.log("[enablePossessionStorage]");
  if (typeof window === "undefined") {
    console.warn("possession storage can't be defined on node environment.");
    return;
  }
  window.__POSSESSION_TIMEOUT__ = 6e5;
};
export {
  enablePossessionStorage
};
